import { log } from './utils';

/**
 * Namespaced, fault-tolerant localStorage wrapper. New namespace (`tdgap_*`)
 * intentionally distinct from the legacy `tdg_*` keys so the new pixel can
 * run side-by-side with the old system during migration.
 */

const NS = 'tdgap_';

export const StorageKeys = {
  journey: NS + 'journey',
  utms: NS + 'utms',
  consent: NS + 'consent',
  version: NS + 'version',
} as const;

function safeAccess(): Storage | null {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    // Test write — some browsers throw in private mode
    const k = NS + 'test';
    window.localStorage.setItem(k, '1');
    window.localStorage.removeItem(k);
    return window.localStorage;
  } catch {
    return null;
  }
}

const storage = safeAccess();

export function get(key: string): string | null {
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch (e) {
    log('storage.get failed', key, e);
    return null;
  }
}

export function set(key: string, value: string): boolean {
  if (!storage) return false;
  try {
    storage.setItem(key, value);
    return true;
  } catch (e) {
    log('storage.set failed', key, e);
    return false;
  }
}

export function remove(key: string): void {
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch (e) {
    log('storage.remove failed', key, e);
  }
}

/** Clear ALL pixel-owned keys. Safe to call on consent revoke. */
export function clearAll(): void {
  if (!storage) return;
  try {
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const k = storage.key(i);
      if (k && k.startsWith(NS)) keys.push(k);
    }
    keys.forEach((k) => storage.removeItem(k));
    log('cleared', keys.length, 'storage keys');
  } catch (e) {
    log('clearAll failed', e);
  }
}
